module.exports = __webpack_public_path__ + "static/media/recerved-seat.e6d5397c.png";